import config from '@/config';
import fetch from '@/fetch';

const BASE_URL = config.url.api.transfeera + '/dashboard';
export default {
  hasBlankslate: () => fetch(`${BASE_URL}/hasBlankslate`)
};
